import { type Product } from '@/features/shop/services/Product/types'

export const getSortedProductIds = (
  products: {
    id: number
  }[],
) =>
  products
    .map((p) => p.id)
    .filter(Boolean)
    .sort((a, b) => a - b)

export function getProductsAspectsForLogging(products: Product[]) {
  const productCount = products.length

  const aspects = products.map((product) => {
    const isVariation =
      product.variationParent ||
      product.variationSize ||
      product.variationColor ||
      product.variationDisplayName ||
      (!!product.variationProducts && product.variationProducts.length > 0)
    const isPromo = !!product.cpgPromotion
    const isSpecialRequest = product.isCustomProduct
    const hasCoupon = !!product.couponId
    const hasAlcoholTerms = product.hasAlcoholTerms

    return {
      isVariation,
      isPromo,
      isSpecialRequest,
      hasAlcoholTerms,
      hasCoupon,
    }
  })

  const hasVariation = aspects.some((a) => a.isVariation)
  const hasPromo = aspects.some((a) => a.isPromo)
  const hasSpecialRequest = aspects.some((a) => a.isSpecialRequest)
  const hasCoupon = aspects.some((a) => a.hasCoupon)
  const hasAlcoholTerms = aspects.some((a) => a.hasAlcoholTerms)

  return {
    productCount,
    hasVariation,
    hasPromo,
    hasSpecialRequest,
    hasCoupon,
    hasAlcoholTerms,
  }
}
